import styled from 'styled-components';

export const TooltipStyled = styled.div`
  position: relative;
  width: 100%;

  .tooltip-container {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 10;
    margin-top: 4px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 4px solid #000000;
    margin-left: 8px;
  }

  .tooltip-content {
    background: #000000;
    color: #ffffff;
    border-radius: 2px;
    padding: 4px 8px;
  }
`;
